var isValidLocale = function isValidLocale(locale) {
  try {
    return typeof Intl.DateTimeFormat(locale) !== 'undefined';
  } catch (_unused) {
    return false;
  }
};
export { isValidLocale };